
import { useState } from "react";
import { Invoice } from "@/types/payments";

export function useInvoiceDetailsDialog() {
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState<Invoice | null>(null);

  const handleRowClick = (invoice: Invoice) => {
    setSelectedInvoice(invoice);
    setDetailsDialogOpen(true);
  };

  return {
    detailsDialogOpen,
    selectedInvoice,
    setSelectedInvoice,
    setDetailsDialogOpen,
    handleRowClick
  };
}
